import { apiClient } from '../client';

export interface PlaceType {
  _id: string;
  name: string;
  description?: string;
  icon?: string;
  color?: string;
  google_types: string[];
  is_active: boolean;
  places_count?: number;
  created_by?: string;
  updated_by?: string;
  createdAt: string;
  updatedAt: string;
}

export interface GoogleType {
  type: string;
  places_count: number;
}

export interface CreatePlaceTypeRequest {
  name: string;
  description?: string;
  icon?: string;
  color?: string;
  google_types: string[];
  is_active?: boolean;
}

export interface UpdatePlaceTypeRequest {
  name?: string;
  description?: string;
  icon?: string;
  color?: string;
  google_types?: string[];
  is_active?: boolean;
}

export const placeTypesAPI = {
  // Get all place types
  getAllPlaceTypes: async (params?: {
    is_active?: boolean;
    search?: string;
  }): Promise<PlaceType[]> => {
    const response = await apiClient.get('/api/admin/place-types', { params });
    return response.data.data;
  },

  // Get place type by ID
  getPlaceTypeById: async (id: string): Promise<PlaceType> => {
    const response = await apiClient.get(`/api/admin/place-types/${id}`);
    return response.data.data;
  },

  // Create new place type
  createPlaceType: async (data: CreatePlaceTypeRequest): Promise<PlaceType> => {
    const response = await apiClient.post('/api/admin/place-types', data);
    return response.data.data;
  },

  // Update place type
  updatePlaceType: async (id: string, data: UpdatePlaceTypeRequest): Promise<PlaceType> => {
    const response = await apiClient.put(`/api/admin/place-types/${id}`, data);
    return response.data.data;
  },

  // Delete place type
  deletePlaceType: async (id: string): Promise<void> => {
    await apiClient.delete(`/api/admin/place-types/${id}`);
  },

  // Get available Google types
  getGoogleTypes: async (): Promise<GoogleType[]> => {
    const response = await apiClient.get('/api/admin/place-types/google-types');
    return response.data.data;
  },
};